var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.params.data.estado===0 && _vm.$can('avance-eliminar'))?_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v("Borrar")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }